import React, { useCallback, useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../../theme/ThemeContext";
import RecentTicketIcon from "../../../../assets/icons/Kraken Icon.svg";
import AuthContext from "../../../../auth/AuthContext";
import TicketDashboardService from "../../../../services/TicketDashboardService";
import AlertService from "../../../../services/AlertService";
import { Skeleton } from "primereact/skeleton";

const avatarBg = "#5841D9";

export default function RecentTickets() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const authContext = useContext(AuthContext);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

const loadDashboard = useCallback(async (signal) => { // 👈
    setLoading(true);
    try {
      const data = await TicketDashboardService.GetRecentTicketsDashboard(
        authContext,
        signal 
      );

      if (signal?.aborted) return;

      if (data.isSuccess) {
        setTickets(
          data.data.map((m) => ({
            from: m.requestedBy,
            subject: m.subject,
            assigned: m.assignedTo,
            date: m.ticketOn,
          }))
        );
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController(); 
    loadDashboard(controller.signal); 
    return () => controller.abort();
  }, [loadDashboard]);

  return (
    <div
      className="charts p-3 d-flex flex-column"
      style={{
        height: "337px",
        width: "100%",
        boxSizing: "border-box",
        border: "1px solid #eee",
        borderRadius: "12px",
        background: isDark ? "#181a22" : "#fff",
      }}
    >
      {/* Title */}
      <div className="mb-3" style={{ fontSize: 16, color: isDark ? "#eee" : "#222" }}>
        {loading ? <Skeleton width="150px" height="20px" /> : "Recent Tickets"}
      </div>

      {/* List */}
      <div className="flex-grow-1 d-flex flex-column overflow-auto scroll-no-buttons">
        {loading
          ? [...Array(4)].map((_, i) => (
              <div
                key={i}
                className={`d-flex align-items-start py-2 py-md-3 gap-2 gap-md-3 ${
                  i === 0 ? "" : "border-top"
                } flex-column flex-md-row`}
              >
                <Skeleton shape="circle" size="32px" className="flex-shrink-0" />
                <div className="flex-grow-1 d-flex flex-column gap-1">
                  <Skeleton width="50%" height="14px" />
                  <Skeleton width="80%" height="12px" />
                </div>
                <div className="d-flex flex-column gap-1 text-end" style={{ minWidth: "80px" }}>
                  <Skeleton width="50px" height="12px" />
                  <Skeleton width="40px" height="10px" />
                </div>
              </div>
            ))
          : tickets.map((ticket, idx) => (
              <div
                key={idx}
                className={`d-flex align-items-start py-2 py-md-3 gap-2 gap-md-3 ${
                  idx === 0 ? "" : "border-top"
                } flex-column flex-md-row`}
              >
                {/* Avatar Icon */}
                <div
                  className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center my-1"
                  style={{
                    width: 40,
                    height: 40,
                    background: avatarBg,
                  }}
                >
                  <img
                    src={RecentTicketIcon}
                    alt="recent"
                    style={{ width: 20, height: 20 }}
                    className="img-fluid"
                  />
                </div>
                {/* Ticket Details */}
                <div className="flex-grow-1">
                  <div
                    className="fw-medium mb-1 "
                    style={{
                      fontSize: 16,
                      color: isDark ? "#eaeaea" : "#222",
                    }}
                  >
                    From: {ticket.from}
                  </div>
                  <div
                    className="text-break"
                    style={{
                      fontSize: 14,
                      color: isDark ? "#ccc" : "#545454",
                    }}
                  >
                    Subject: {ticket.subject}
                  </div>
                </div>
                {/* Right side details */}
                <div
                  className="d-flex flex-column align-items-md-end"
                  style={{ minWidth: 100 }}
                >
                  <span
                    className="fw-medium"
                    style={{
                      fontSize: 14,
                      color: isDark ? "#eaeaea" : "#222",
                    }}
                  >
                    Assigned: {ticket.assigned}
                  </span>
                  <span
                    style={{ color: "#888", fontSize: 13, marginTop: 3 }}
                  >
                    {ticket.date}
                  </span>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}